import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const approveClaim = (claim, allowDuplicates = false) =>
  call(websocketFetch, 'approve_claim', {
    ...claim,
    allow_potential_duplicate_claims: allowDuplicates,
    version: 1,
  });
